import { render, staticRenderFns } from "./updateform.vue?vue&type=template&id=01e63538&scoped=true&"
import script from "./updateform.vue?vue&type=script&lang=js&"
export * from "./updateform.vue?vue&type=script&lang=js&"
import style0 from "./updateform.vue?vue&type=style&index=0&id=01e63538&prod&lang=scss&scoped=true&"
import style1 from "./updateform.vue?vue&type=style&index=1&id=01e63538&prod&lang=css&"
import style2 from "./updateform.vue?vue&type=style&index=2&id=01e63538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e63538",
  null
  
)

export default component.exports